import { CUSTOM_EVENTS_TYPES } from './VideoPlayer';

export const PLYR_CONTROLS = {
  playLarge: 'play-large',
  play: 'play',
  progress: 'progress',
  currentTime: 'current-time',
  mute: 'mute',
  volume: 'volume',
  captions: 'captions',
  settings: 'settings',
  pip: 'pip',
  airplay: 'airplay',
  fullscreen: 'fullscreen',
};

export const PLYR_EVENTS = {
  ready: 'ready',
  play: 'play',
  pause: 'pause',
  ended: 'ended',
  timeupdate: 'timeupdate',
};

export const CUSTOM_EVENTS: CUSTOM_EVENTS_TYPES = {
  start: 'videoPlayerStart',
  stop: 'videoPlayerStop',
  ready: 'videoPlayerReady',
};
